import {
    faCalendarCircleUser,
    faGear,
    faHouseWindow,
    faPersonCircleCheck,
    faReceipt,
} from "@fortawesome/pro-solid-svg-icons"
import {
    SERVICE_CENTER_ADMIN_ROUTE,
    SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_ROOMS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
    SERVICE_CENTER_REPORTS_ROUTE,
} from "../../../constants/routes"
import { NarrowNavItem } from "../../../shared/layouts/NarrowNavItems"
import { EnvironmentType } from "../../environment/envTypes"

// `environments` lists the envs where a nav item is SHOWN; omit it to show everywhere.
const defaultEnvs = [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]

// Pages whose API isn't ready yet — shown only in Local/Test/Demo (hidden in QA & Prod).
const apiNotReadyEnvs = [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]

export const serviceCenterReportingNavItems: NarrowNavItem[] = [
    {
        icon: faHouseWindow,
        label: "User",
        translationLabel: "service-center-nav-item-user-label",
        route: SERVICE_CENTER_REPORTS_ROUTE,
    },
    {
        icon: faReceipt,
        label: "Canteen",
        translationLabel: "service-center-nav-item-canteen-label",
        route: SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
        environments: apiNotReadyEnvs,
    },
    {
        icon: faCalendarCircleUser,
        label: "Meeting rooms",
        translationLabel: "service-center-nav-item-meeting-rooms-label",
        route: SERVICE_CENTER_REPORTS_MEETING_ROOMS_ROUTE,
        environments: apiNotReadyEnvs,
    },
    {
        icon: faPersonCircleCheck,
        label: "Guests",
        translationLabel: "service-center-nav-item-guests-label",
        route: SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.Prod],
    },
    {
        icon: faGear,
        label: "Settings",
        translationLabel: "service-center-nav-item-settings-label",
        route: SERVICE_CENTER_ADMIN_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.Prod],
    },
]
